import { createAction, props } from '@ngrx/store';
import {
  Workflow,
  WorkflowStep,
  WorkflowStepAction,
  WorkflowStepRule,
  WorkflowRuleImplementation,
  WorkflowParentType,
  WorkflowStatus
} from 'src/app/modules/core/store/models/workflow.model';
import { QueryParams, QueryResult } from 'src/app/modules/core/store/models/query.model';

//
// Workflow Page actions
//
export const setSelectedWorkflow = createAction('[Comms/Workflow/Page] Set Selected Workflow', props<{ workflow: Workflow }>());
export const setUpdatedWorkflow = createAction('[Comms/Workflow/Page] Set Updated Workflow', props<{ workflow: Workflow }>());
export const configureWorkflow = createAction('[Comms/Workflow/Page] Configure Workflow');
export const editSelectedWorkflow = createAction('[Comms/Workflow/Page] Edit Selected Workflow');
export const setWorkflowStepForDelete = createAction(
  '[Comms/Workflow/Page] Set Workflow Step for Delete',
  props<{ workflowStep: WorkflowStep }>()
);
export const setWorkflowStepsForDeleteComplete = createAction(
  '[Comms/Workflow/API] Get Workflow Steps For Deletion Complete',
  props<{ deleteStep: WorkflowStep; results: WorkflowStep[] }>()
);
export const clearWorkflowStepForDelete = createAction('[Comms/Workflow/Page] Clear Workflow Step for Delete');
export const setWorkflowActionForDelete = createAction(
  '[Comms/Workflow/Page] Set Workflow Action for Delete',
  props<{ workflowStep: WorkflowStep; action: WorkflowStepAction }>()
);
export const clearWorkflowStepActionForDelete = createAction('[Comms/Workflow/Page] Clear Workflow Action for Delete');
export const setError = createAction('[Comms/Workflow/Page] Set Error', props<{ err: any }>());
export const setIsWorking = createAction('[Comms/Workflow/Page] Is Working', props<{ isWorking: boolean }>());

//
// Workflow API actions
//
export const getWorkflow = createAction('[Comms/Workflow/API] Get Workflow', props<{ workflowUId: string }>());
export const getWorkflowForDataset = createAction('[Comms/Workflow/API] Get Workflow For Dataset', props<{ datasetUId: string }>());
export const getWorkflowForDatasetComplete = createAction(
  '[Comms/Workflow/API] Get Workflow For Dataset Complete',
  props<{ workflow: Workflow }>()
);
export const saveSelectedWorkflow = createAction('[Comms/Workflow/API] Save Selected Workflow', props<{ close: boolean }>());
export const updateWorkflow = createAction('[Comms/Workflow/API] Update Workflow', props<{ workflow: Workflow; close: boolean }>());
export const updateWorkflowComplete = createAction('[Comms/Workflow/API] Update Workflow Complete', props<{ workflow: Workflow }>());
export const createWorkflow = createAction('[Comms/Workflow/API] Create Workflow', props<{ workflow: Workflow; close: boolean }>());

//
// Workflow Step API actions
//
export const getWorkflowSteps = createAction('[Comms/Workflow/API] Get Workflow Steps', props<{ workflowUId: string }>());
export const getWorkflowStepsComplete = createAction(
  '[Comms/Workflow/API] Get Workflow Steps',
  props<{ results: QueryResult<WorkflowStep> }>()
);
export const addWorkflowStep = createAction('[Comms/Workflow/API] Add Workflow Step');
export const updateWorkflowStep = createAction('[Comms/Workflow/API] Update Workflow Step', props<{ workflowStep: WorkflowStep }>());
export const deleteWorkflowStep = createAction('[Comms/Workflow/API] Delete Workflow Step');
export const moveWorkflowStep = createAction(
  '[Comms/Workflow/API] Move Workflow Step',
  props<{
    previousIndex: number;
    currentIndex: number;
  }>()
);

//
// Workflow Step Action actions
//
export const addWorkflowStepAction = createAction('[Comms/Workflow/API] Add Workflow Step Action', props<{ workflowStep: WorkflowStep }>());
export const updateWorkflowStepAction = createAction(
  '[Comms/Workflow/API] Update Workflow Step Action',
  props<{ workflowStep: WorkflowStep; stepAction: WorkflowStepAction }>()
);
export const deleteWorkflowStepAction = createAction('[Comms/Workflow/API] Delete Workflow Step Action');
export const moveWorkflowStepAction = createAction(
  '[Comms/Workflow/API] Move Workflow Step Action',
  props<{
    workflowStep: WorkflowStep;
    previousIndex: number;
    currentIndex: number;
  }>()
);

export const setIsDirty = createAction('[Comms/Workflow/Page] Set Is Workflow Dirty', props<{ isDirty: boolean }>());

export const addWorkflowStepRule = createAction('[Comms/Workflow/Page] Add Workflow Step Rule', props<{ step: WorkflowStep }>());
export const editWorkflowStepRule = createAction(
  '[Comms/Workflow/Page] Edit Workflow Step Rule',
  props<{ step: WorkflowStep; rule: WorkflowStepRule }>()
);
export const setWorkflowStepRuleForDelete = createAction(
  '[Comms/Workflow/Page] Set Workflow Step Rule for Delete',
  props<{ step: WorkflowStep; rule: WorkflowStepRule }>()
);
export const clearWorkflowStepRuleForDelete = createAction('[Comms/Workflow/Page] Clear Workflow Step Rule for Delete');
export const deleteSelectedWorkflowStepRule = createAction('[Comms/Workflow/Page] Delete Selected Workflow Step Rule');
export const setSelectedWorkflowStepRule = createAction(
  '[Comms/Workflow/Page] Set Selected Workflow Step Rule',
  props<{ step: WorkflowStep; rule: WorkflowStepRule }>()
);
export const clearSelectedWorkflowStepRule = createAction('[Comms/Workflow/Page] Clear Selected Workflow Step Rule');
export const loadWorkflowRuleImplementations = createAction(
  '[Comms/Workflow/Page] Load Rule Implementations',
  props<{ parentType: WorkflowParentType }>()
);
export const loadWorkflowRuleImplementationsComplete = createAction(
  '[Comms/Workflow/Page] Load Rule Implementations Complete',
  props<{ ruleImplementations: WorkflowRuleImplementation[] }>()
);
export const saveWorkflowStepRule = createAction(
  '[Comms/Workflow/Page] Save Workflow Rule',
  props<{ step: WorkflowStep; rule: WorkflowStepRule }>()
);
export const moveWorkflowStepRule = createAction(
  '[Comms/Workflow/API] Move Workflow Step Rule',
  props<{ workflowStep: WorkflowStep; previousIndex: number; currentIndex: number }>()
);
export const moveWorkflowStepMember = createAction(
  '[Comms/Workflow/API] Move Workflow Step Member',
  props<{ workflowStep: WorkflowStep; previousIndex: number; currentIndex: number }>()
);

export const editWorkflow = createAction('[Comms/Workflow/Page] Edit Workflow', props<{ workflow: Workflow }>());
export const deleteWorkflow = createAction('[Comms/Workflow/Page] Delete Workflow', props<{ workflow: Workflow }>());
export const newWorkflow = createAction('[Comms/Workflow/Page] New Workflow', props<{ parentType: WorkflowParentType; name: string }>());
export const newWorkflowComplete = createAction('[Comms/Workflow/Page] New Workflow Complete', props<{ workflow: Workflow }>());
export const setTableChanged = createAction('[Comms/Workflow/Page] Set Table Changed', props<{ changed: boolean }>());
export const setWorkflowActive = createAction(
  '[Comms/Workflow/Page] Set Workflow Active',
  props<{ active: boolean; workflow: Workflow }>()
);

export const setWorkflowDefault = createAction(
  '[Comms/Workflow/Page] Set Workflow Default',
  props<{ default: boolean; workflow: Workflow }>()
);

// Workflow Statuses
export const getStatuses = createAction('[Comms/Workflow/Status/API] Get Statuses', props<{ queryParams: Partial<QueryParams> }>());
export const loadStatuses = createAction('[Comms/Workflow/Status/API] Load Statuses', props<QueryResult<WorkflowStatus>>());
